import helpers from "@kinetics254/cassandra-base/utilities/helpers/helper";
import moment from "moment/moment";
class PettyCashMethods {
  methods() {
    return {
      pettyCashForm: function () {
        if (!this.isValid) {
          this.$refs.pettyCashForm.validate();
        } else {
          // post data
          delete this.formData.totalAmount;
          this.formData.attachments = [];
          this.formData.attachments = this.attachmentBase64;
          let data = { ...this.formData };
          data.payeeName = `${this.employee.firstName} ${this.employee.lastName}`;
          data = this.updateLines(data);
          delete data.totalAmount;
          this.$route.query.edit
            ? this.$store.dispatch("pettycash/editPettyCash", data)
            : this.$store.dispatch("pettycash/submitPettyCash", data);
        }
      },
      updateLines: function (data) {
        data.employee_no = this.employee.number;
        data.employeeName = `${this.employee.firstName} ${this.employee.lastName}`;
        data.pettyCashLinesAPI.map(async (line) => {
          line.amount = parseFloat(line.amount);
          if (!this.$route.query.edit) {
            delete line.documentNo;
          }
          return line;
        });
        return data;
      },
      mapPettycashLines: function (data) {
        data.pettyCashLinesAPI.map(async (line) => {
          line.amount = parseFloat(line.amount);
          delete line.attachment;
          if (!this.$route.query.edit) {
            delete line.documentNo;
          }
          delete line.attachmentName;
          if (line.attachmentBlob) {
            delete line.attachmentBlob;
          }
          return line;
        });
      },

      deletePettyCash: function () {
        this.$confirm.show({
          text: "Are you sure you want to delete this request?",
          onConfirm: () => {
            this.$store.dispatch("pettycash/deletePettyCash", {
              ...this.formData,
            });
          },
        });
      },
      getColor(status) {
        return helpers.getColor(status);
      },

      getDateFormat(date) {
        return helpers.getDateFormat(date);
      },

      addItem: function (item) {
        this.isEditLines = false;
        this.pettycashLine.description = item.description;
        this.pettycashLine.expenseCode = item.code;
        this.itemDialog = true;
        const fileInput = this.$refs.fileInput;
        if (fileInput !== undefined) fileInput.reset();
      },

      editExpenseCode: async function () {
        this.pettycashLine.postingDate = moment(new Date()).format(
          "YYYY-MM-DD"
        );
        this.formData.pettyCashLinesAPI = this.formData.pettyCashLinesAPI.map(
          (item) => {
            if (item.expenseCode === this.pettycashLine.expenseCode)
              item = { ...this.pettycashLine };
            return item;
          }
        );
        this.pettycashLine = {};
        this.itemDialog = false;
      },

      toBase64: (file) =>
        new Promise((resolve, reject) => {
          if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
          }
        }),
      downloadLink(fileLink) {
        const a = document.createElement("a");
        a.href = process.env.VUE_APP_FILE_API + fileLink;
        a.download = process.env.VUE_APP_FILE_API + fileLink;
        a.click();
      },
      autosaveExpenseItem: async function () {
        if (this.expenseItemIndex > -1) {
          this.expenseItem.code = this.expenseItem.expenseCode;
          if (this.$route.query.edit) {
            this.expenseItem.documentNo = this.formData.no;
            this.expenseItem.documentType = this.formData.documentType;
          } else {
            this.expenseItem.postingDate = moment(new Date()).format(
              "YYYY-MM-DD"
            );
            delete this.expenseItem.documentNo;
            delete this.expenseItem.documentType;
          }
          Object.assign(
            this.expenseItemsList[this.expenseItemIndex],
            this.expenseItem
          );
        }
      },
      displayConditionally(item) {
        if (item !== null) {
          if ("lineNo" in item) {
            if (item.lineNo === this.expenseItem.lineNo) {
              return true;
            }
            return false;
          } else if ("id" in item) {
            if (item.id === this.expenseItem.id) {
              return true;
            }
          }
        }
        return false;
      },
      editItem(item) {
        this.expenseItem = { ...item };
        this.expenseItemIndex = this.expenseItemsList.indexOf(item);
        this.expenseItem = Object.assign({}, { ...item });
      },
      deleteLine: function (item) {
        if (item.lineNo) {
          this.$confirm.show({
            text: "Are you sure you want to remove this Item?",
            onConfirm: () => {
              this.$store.dispatch("pettycash/deletePettyCashLines", item);
              for (const i in this.formData.pettyCashLinesAPI) {
                if (
                  this.formData.pettyCashLinesAPI[i].lineNo === item.lineNo
                ) {
                  this.formData.pettyCashLinesAPI.splice(i, 1);
                  break;
                }
              }
            },
          });
        } else {
          for (const i in this.formData.pettyCashLinesAPI) {
            if (
              this.formData.pettyCashLinesAPI[i].expenseCode ===
              item.expenseCode
            ) {
              this.formData.pettyCashLinesAPI.splice(i, 1);
              break;
            }
          }
        }
      },
      closeDialog: function (val) {
        this.itemDialog = val;
      },
      close() {
        setTimeout(() => {
          this.expenseItem = Object.assign({}, this.defaultExpenseItem);
          this.expenseItemIndex = -1;
        }, 300);
      },
      addNew() {
        const addObj = Object.assign({}, this.defaultExpenseItem);
        addObj.id = this.expenseItemsList.length + 1;
        this.expenseItemsList.unshift(addObj);
        this.editItem(addObj);
        if (this.$route.query.edit) {
          this.expenseItem.documentNo = this.formData.no;
          this.expenseItem.documentType = this.formData.documentType;
        }
        this.expenseItem.shortcutDimension1Code =
          this.formData.shortcutDimension1Code;
        this.expenseItem.shortcutDimension2Code =
          this.formData.shortcutDimension2Code;
        this.expenseItem.shortcutDimension3Code =
          this.formData.shortcutDimension3Code;
        this.expenseItem.shortcutDimension4Code =
          this.formData.shortcutDimension4Code;
      },
      selectExpenseCode: function (code) {
        let selectedItem = this.expenseItems.find((item) => item.code === code);
        this.expenseItem.description = selectedItem.description;
        const travel = this.transportRates.find(
          ({ expenseCode }) => expenseCode === this.expenseItem.expenseCode
        );
        if (travel !== undefined) {
          this.expenseItem.transportCode = travel ? travel.code : "";
          this.expenseItem.to = travel ? travel.to : "";
          this.expenseItem.from = travel ? travel.from : "";
          this.expenseItem.amount = travel
            ? travel.rate
            : this.expenseItem.amount;
        }
      },
      addDimensions(item) {
        delete item.documentDate;
        delete this.documentType;
        this.expenseItem = Object.assign({}, { ...item });
        this.itemDialog = true;
      },
      updateDimensions(val) {
        if ("line_no" in val) {
          Object.assign(
            this.expenseItemsList[
              this.expenseItemsList.findIndex(
                (el) => el.lineNo === val.line_no
              )
            ],
            this.expenseItem
          );
        } else if ("id" in val) {
          Object.assign(
            this.expenseItemsList[
            this.expenseItemsList.findIndex((el) => el.id === val.id)
            ],
            this.expenseItem
          );
        }
      },
      sendForApproval: function (method) {
        if (!this.isValid) {
          this.$refs.pettyCashForm.validate();
        } else {
          this.formData.attachments = [];
          delete this.formData.total_amount;
          let data = {
            ...this.formData,
            method,
          };
          this.formData.attachments = this.attachmentBase64;
          data = this.updateLines(data);
          const params = {
            title: "Send Approval Request",
            text: "Are you sure you want to send this request for approval?",
            onConfirm: () => {
              this.$store.dispatch("pettycash/saveAndSendforApproval", data);
            },
          };
          this.$confirm.show(params);
        }
      },
      cancelApprovalRequest: function () {
        const data = {
          headerNo: this.formData.no,
        };
        const params = {
          title: "Cancel Approval Request",
          text: "Are you sure you want to cancel this request?",
          onConfirm: () => {
            this.$store.dispatch("pettycash/cancelApprovalRequest", {
              ...data,
            });
          },
        };
        this.$confirm.show(params);
      },
      removeBase64(item) {
        const itemIndex = this.attachmentBase64.findIndex(
          (el) => el.fileName === item
        );
        const itemBlobIndex = this.attachmentBase64.findIndex(
          (file) => file.name === item
        );
        this.attachmentBase64.splice(itemIndex, 1);
        this.attachmentBlobs.splice(itemBlobIndex, 1);
      },
    };
  }
}

export default new PettyCashMethods().methods();
